module.exports = __webpack_public_path__ + "static/media/systemDown.446af0dd.svg";